import { memo } from '@fantastic-utils/memo';
import inRange from "lodash/inRange";
import { BREAKPOINTS } from "@/constants/Core";

export const getDeviceBreakpointGroup = memo((width) => {
    
    const breakpoints = {
        xs: [0, BREAKPOINTS.PHONE],
        sm: [BREAKPOINTS.PHONE+1, BREAKPOINTS.TABLET],
        md: [BREAKPOINTS.TABLET+1, BREAKPOINTS.DESKTOP],
        lg: [BREAKPOINTS.DESKTOP+1, 1007],
        xl: [1008, 1279],
        xxl: [1280, 8192],
      };

    for (let group in breakpoints) {
        
        if (inRange(width, breakpoints[group][0], breakpoints[group][1]))
            return group;
    }

});